<template>
    <el-dialog title="" :visible.sync="dialog" :close-on-press-escape="false" :before-close="reset" :show-close="false"
        width="420px" center>
        <div class="yijing-container flex flex-direction">
            <div class="title self-center">紧急预警</div>
            <div class="classify margin-tb-sm">
                <i class="icon iconfont icon-jinggao2"></i>
                {{ detail.service_type | service_type }}预警
            </div>
            <div class="info">{{ detail.xiaoqu_name }}
                <span v-if="detail.show_address">{{ detail.building_name }}{{ detail.element_name }}单元{{ detail.room_name
                    }}</span>
                <span v-else @click="detail.show_address = true">****</span>
            </div>
            <div class="info margin-top-xs">{{ detail.name }} |
                <span v-if="detail.show_phone">{{ detail.phone }}</span>
                <span v-else @click="detail.show_phone = true">{{ detail.phone | formatPhone }}</span>
            </div>
            <!--            <div class="tips self-center margin-top-sm">———— 请立即联系监测对象 ————</div>-->
            <div class="flex flex-wrap justify-between margin-top-sm">
                <el-tooltip :content="detail.emergency_contact" placement="top">
                    <el-button class="operate" :loading="loading">联系当事人</el-button>
                </el-tooltip>
                <el-tooltip placement="top">
                    <template slot="content">
                        110 — 匪警电话<br>119 — 火警电话<br>120 — 急救电话
                    </template>
                    <el-button class="operate" :loading="loading">拨打急救电话</el-button>
                </el-tooltip>
                <el-tooltip :content="detail.emergency_contact" placement="top">
                    <el-button class="operate margin-top-xs" :loading="loading">联络紧急联络人</el-button>
                </el-tooltip>
                <el-button class="operate margin-top-xs" :loading="loading" @click="imageDialog = true"
                    v-if="detail.state === 3">已结项</el-button>
                <el-button class="operate margin-top-xs" :loading="loading" @click="imageDialog = true"
                    v-else>已办结，拍照结项</el-button>
            </div>
        </div>
        <el-dialog title="" :visible.sync="imageDialog" :close-on-click-modal="false" :close-on-press-escape="false"
            append-to-body :show-close="false" top="9%" width="390px" center>
            <div class="yijing-container flex flex-direction">
                <div class="title self-center">拍照结项</div>
                <el-image class="avatar margin-top-sm self-center" :src="detail.images" fit="contain"
                    v-if="detail.images" :preview-src-list="[detail.images]"></el-image>
                <el-upload class="avatar-uploader margin-top-sm self-center" ref="upload" accept="image/*"
                    :action="upUrl" :name="'file'" :data="QiniuData" :before-upload="beforeAvatarUpload"
                    :show-file-list="false" :on-success="handleAvatarSuccess" v-if="detail.state !== 3">
                    <el-image class="avatar" v-if="image" :src="image" fit="contain"></el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="flex flex-wrap justify-between margin-top-sm">
                    <el-button class="operate" :loading="loading" @click="cancel">取消</el-button>
                    <el-button class="operate" :loading="loading" @click="sureSet" v-if="!detail.images">提交</el-button>
                    <el-button class="operate" :loading="loading" @click="imageDialog = false" v-else>确定</el-button>
                </div>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>

import { devTypeList, filesCN, formatPhone, getQNFileKey, zhDate } from "@/utils/utils";
import { setSaveDeviceState } from "@/api/tongji";
import { FILE_UPLOAD_HOST_QN } from "@/config";
import { getQNToken } from "@/utils/CryptoJS";
import { getQiniuUrl } from "@/api/common";

export default {
    name: "SafetyYujingDialog",
    data() {
        return {
            upUrl: FILE_UPLOAD_HOST_QN,
            imageDialog: false,
            image: '',
            loading: false,

            QiniuData: {
                fname: '', //  文件名
                key: '', //文件名字处理
                token: getQNToken() //七牛云token
            },
        }
    },
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        detail: {
            type: [String, Object],
            default: ''
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                token: this.user.token,
                addWatermark: 0
            };
        },
    },
    methods: {
        async sureSet() {
            this.loading = true
            let _state = await setSaveDeviceState(this.detail.id, this.image)
            this.loading = false
            if (_state.status === 200) {
                this.imageDialog = false
                this.$message.success(_state.info);
                this.$emit('cancelDialog', true)
            } else {
                this.$message.error(_state.info);
            }
        },
        cancel() {
            this.imageDialog = false
            this.image = ''
        },
        //  取消
        reset() {
            this.$emit('cancelDialog', false)
        },
        //  上传钱判断
        beforeAvatarUpload(file) {
            this.QiniuData.fname = file.name;
            this.QiniuData.key = getQNFileKey(`${new Date().getTime()}${file.name}`)
        },
        //  上传成功
        async handleAvatarSuccess(res, file) {
            // if (res.status === 200) {
            let _data = await getQiniuUrl(res.key)
            this.image = _data.data.url
            // } else {
            //     this.$message.error(res.info)
            // }
        },
    },
    watch: {},
    filters: {
        date_time(val) {
            return zhDate(val, 8)
        },
        service_type(val) {
            return filesCN(Number(val), devTypeList)
        },
        formatPhone(val) {
            return formatPhone(val)
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ {
    .el-dialog {
        background-image: linear-gradient(0deg,
                #0c5da3aa 0%,
                #002262aa 100%),
            linear-gradient(#002262aa,
                #002262aa);
        background-blend-mode: normal,
            normal;

        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            padding: 0;
        }

    }

    .yijing-container {
        padding: 0 31px 28px;

        .title {
            background: url(../../../assets/img/data/bg_monitoring_title.png) no-repeat top;
            background-size: 100% 100%;
            width: 242px;
            height: 41px;
            line-height: 41px;
            text-align: center;
            font-size: 18px;
            font-weight: 600;
            color: #ff3a3a;
        }

        .classify {
            height: 46px;
            line-height: 46px;
            background-color: #ff9454;
            border-radius: 3px;
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: #ffffff;

            .icon {
                font-size: 22px;
                color: #ffd200;
            }
        }

        .info {
            font-size: 13px;
            color: #ffffff;
        }

        .tips {
            font-size: 18px;
            color: #ffd200;
        }

        .operate+.operate {
            margin-left: 0;
        }

        .operate {
            width: 160px;
            height: 41px;
            line-height: 41px;
            text-align: center;
            padding: 0;
            border: none;
            background-image: linear-gradient(0deg,
                    #198bff 0%,
                    #19caff 100%),
                linear-gradient(#27447d,
                    #27447d);
            background-blend-mode: normal,
                normal;
            border-radius: 11px;
            font-size: 14px;
            color: #ffffff;
            cursor: pointer;
        }
    }
}

.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    display: block;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 128px;
    line-height: 128px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 128px;
    display: block;
    border: 1px dashed #d9d9d9;

    &.active {
        width: 400px;
        height: 300px;
    }
}
</style>